<template>
  <or-popover
    data-component="base-search-date-time-popup"
    placement="bottom-start"
    :trigger="trigger"
    :is-open="isOpen"
  >
    <base-date-time-range-picker
      class="base-date-time-range-picker"
      :datetime="value"
      :min-date-filter="minDateFilter"
      :max-date-filter="maxDateFilter"
      initial-range-direction="backward"
      @click.stop
      @datetime-change="onDateTimeConfirm"
      @cancel="onDatePickerClosed"
    />
  </or-popover>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi';
import { OrPopoverV3 as OrPopover } from '@onereach/ui-components-25';

import BaseDateTimeRangePicker from '../common/BaseDateTimeRangePicker.vue';
import { QueryDateValue, WritableQueryDateValue } from '../../types';
import { PARAM_PROP } from '../../constants';

/** Do not propagate click events to keep Search Input in focus */
export default defineComponent({
  name: 'BaseSearchDateTimePopup',
  components: {
    OrPopover,
    BaseDateTimeRangePicker,
  },
  props: {
    trigger: {
      type: Object as PropType<HTMLElement>,
      default: () => ({}),
    },
    param: PARAM_PROP,
    isOpen: Boolean,
  },

  emits: ['param-change', 'close'],

  setup(props, ctx) {
    const value = computed(() => (props.param.value || {}) as QueryDateValue);

    function minDateFilter(range: WritableQueryDateValue) {
      return (date: Date) => {
        if (range.to) {
          return date <= range.to;
        } else return date <= new Date();
      };
    }

    function maxDateFilter(range: WritableQueryDateValue) {
      return (date: Date) => {
        if (range.from) {
          return date >= range.from;
        }
        return date <= new Date();
      };
    }

    function onDateTimeConfirm(datetime: QueryDateValue) {
      const param = { key: props.param.key, value: datetime };
      ctx.emit('param-change', param);
    }

    function onDatePickerClosed() {
      ctx.emit('close', props.param.key);
    }

    return {
      value,
      minDateFilter,
      maxDateFilter,
      onDateTimeConfirm,
      onDatePickerClosed,
    };
  },
});
</script>

<style lang="scss">
@use '@/styles' as *;

.base-date-time-range-picker {
  width: 100%;

  @include md {
    width: 572px;
  }
}
</style>
